module.exports = __webpack_public_path__ + "img/screen-img-01.a61cf2c2.webp";